
import * as axios from "@/store/http";
import { validatorPortal } from "@/pcpage/hr/recruitment/portal/component/portalValidator.js";
export default {
  name: "commportallogin",
  data() {
    return {
      //date1:'',
      record: {
        email: "",
        emailcode: "",
        password: "",
        password2: "",
        educationlist: [{}],
        experiencelist: [{}],
        portalfilelist: [], //附件
        deleducationlist: [],
        delexperiencelist: [],
      }, //用户注册信息
      ifpassworderror: false,
      rules: {
        email: [
          {
            required: true,
            message: 11111,
            validator: validatorPortal,
            trigger: "blur",
          },
        ],
      },
      successRoute: "/portal/successOperate", //注册成功URL
      saveUrl: "api/api/portalLogin/createAccount", //
    };
  },
  methods: {
    sumbitForm() {
      //提交表单
      let params = {
        record: this.record,
      };
      this.axios
        .post(this.saveUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            this.$router.push({
              path: this.successRoute,
              query: {},
            });
          } else {
            this.$msgDailog.showMsgBox({
              title: "Login has failed",
            });
          }
        })
        .catch((error) => console.log(error));
    },
    passwordFocus() {
      this.ifpassworderror = true;
    },
    async checkForm(indexStep) {
      //表单验证
      let aForm = [];
      let sMainFormName = "rulesForm1";
      let flag = true;
      if (indexStep == 2) {
        sMainFormName == "rulesForm1";
        flag = this.checkForm1();
      } else if (indexStep == 3) {
        flag = this.checkForm2();
      } else if (indexStep == 4) {
        flag = this.checkForm3(this.record);
      }
      return flag;
    },
    async checkForm1() {
      //表单1验证
      let email = this.record.email;
      let emailcode = this.record.emailcode;
      let password = this.record.password;
      let password2 = this.record.password2;
      if (!this.isNotNullOrEmpty(email)) {
        this.$msgDailog.showMsgBox({
          title: "Email Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(emailcode)) {
        this.$msgDailog.showMsgBox({
          title: "Validation Code Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(password)) {
        this.$msgDailog.showMsgBox({
          title: "Password Required",
        });
        return false;
      }
      if (password != password2 || !this.passwordpass) {
        this.$msgDailog.showMsgBox({
          title: "Password Error",
        });
        return false;
      }
      let msg = await this.checkEmailCode();
      if (msg != "1") {
        this.$msgDailog.showMsgBox({
          title: "Incorrect Varification Code",
        });
        return false;
      }
      return true;
    },
    checkForm2() {
      //表单2验证
      let firstname = this.record.firstname;
      let lastname = this.record.lastname;
      let middlename = this.record.middlename; 
      let birthday = this.record.birthday;
      let phone = this.record.phone;
      let emailaddress = this.record.emailaddress;
      if (!this.isNotNullOrEmpty(firstname)) {
        this.$msgDailog.showMsgBox({
          title: "First Name Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(lastname)) {
        this.$msgDailog.showMsgBox({
          title: "Last Name Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(middlename)) {
        this.$msgDailog.showMsgBox({
          title: "Middle Name Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(birthday)) {
        this.$msgDailog.showMsgBox({
          title: "Date of Birth Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(phone)) {
        this.$msgDailog.showMsgBox({
          title: "Phone Number Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(emailaddress)) {
        this.$msgDailog.showMsgBox({
          title: "Email Address Required",
        });
        return false;
      }
      return true;
    },
    checkForm3(obj) {
      //表单2验证
      let educationlist = obj.educationlist;
      let experiencelist = obj.experiencelist;
      let introduction = obj.introduction;
      let portalfilelist = obj.portalfilelist;
      let issponsorvisa = obj.issponsorvisa;
      if (portalfilelist.length == 0) {
        this.$msgDailog.showMsgBox({
          title: "Resume Attachment is required.",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(introduction)) {
        this.$msgDailog.showMsgBox({
          title: "Career Summary is required.",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(issponsorvisa)) {
        this.$msgDailog.showMsgBox({
          title: "Do you need a company to sponsor your work visa now or in the future is required.",
        });
        return false;
      }
      let msg = "";
      if (educationlist.length > 0) {
        let i = 1;
        for (let edu of educationlist) {
          if (!this.isNotNullOrEmpty(edu.educationstatus)) {
            msg +=
              "Status (Education - Group " +
              i +
              ") is required. </br>";
          }
          if (edu.educationstatus && (edu.educationstatus == '01' || edu.educationstatus == '02')) {
            if (!this.isNotNullOrEmpty(edu.degree)) {
              msg +=
                "Degree/Certificate (Education - Group " +
                i +
                ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(edu.schoolname)) {
              msg +=
                "University/School (Education - Group " +
                i +
                ") is required. </br>";
            }
            if (edu.educationstatus == '01' && (!this.isNotNullOrEmpty(edu.begindate) || !this.isNotNullOrEmpty(edu.enddate))) {
              msg += "Duration (Education - Group " + i + ") is required. </br>";
            } else if (edu.educationstatus == '02'&& !this.isNotNullOrEmpty(edu.begindate)){
              msg += "Duration (Education - Group " + i + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(edu.edumajor)) {
              msg +=
                "Course (Education - Group " +
                i +
                ") is required. </br>";
            }
          }
          i++;
        }
      }
      if (experiencelist.length > 0) {
        let i = 1;
        for (let exp of experiencelist) {
          if (!this.isNotNullOrEmpty(exp.experiencestatus)) {
            msg +=
              "Do you have previous employment (Experience - Group " +
              i +
              ") is required. </br>";
          }
          if (exp.experiencestatus && (exp.experiencestatus == '1' || exp.experiencestatus == '2')) {
            if (!this.isNotNullOrEmpty(exp.company)) {
              msg +=
                "Company/Project (Experience - Group " +
                i +
                ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(exp.position)) {
              msg +=
                "Postion/Role (Experience - Group " + i + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(exp.description)) {
              msg +=
                "Description (Experience - Group " + i + ") is required. </br>";
            }
            if (exp.experiencestatus == '1') {
              if (
                !this.isNotNullOrEmpty(exp.begindate) ||
                !this.isNotNullOrEmpty(exp.enddate)
              ) {
                msg += "Duration (Experience - Group " + i + ") is required. </br>";
              }
            } else {
              if (!this.isNotNullOrEmpty(exp.begindate)) {
                msg += "Duration (Experience - Group " + i + ") is required. </br>";
              }
            }
            if (!this.isNotNullOrEmpty(exp.superleader)) {
              msg += "Reference Name (Experience - Group " + i + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(exp.superleaderpost)) {
              msg += "Reference Position (Experience - Group " + i + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(exp.superleadercontact)) {
              msg += "Reference Contact Number (Experience - Group " + i + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(exp.superleaderemail)) {
              msg += "Reference Email Address (Experience - Group " + i + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(exp.superleaderrelate)) {
              msg += "Work Relationship of the Reference to the Candidate (Experience - Group " + i + ") is required. </br>";
            }
          }
          i++;
        }
      }
      if (msg != "") {
        this.$msgDailog.showMsgBox({
          title: msg,
        });
        return false;
      }
      return true;
    },
    checkPassword() {
      //正则验证密码
      let flag = true;
      if (!this.isNotNullOrEmpty(this.record.password)) {
        //this.tipDefault("Please Enter Password First");
        this.ifpassworderror = false;
        flag = false;
      } else {
        //校验邮箱是否符合规范
        let password = this.record.password;
        let checkReg =
          /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&_*,\\.]{7,}$/;
        //^.* 指任意字符
        //(?=.*[0-9])任意字符串后有一数字
        //(?=.*[A-Z])任意字符串后有一大写字母
        //(?=.*[a-z])任意字符串后有一小写字母
        //(?=.*[!@#$%^&*?])任意字符串后有一括号里的特殊字符
        //\w{7,}   指长度要大于8位
        if (!checkReg.test(password)) {
          this.ifpassworderror = true;
          this.passworderror = true;
          this.passwordpass = false;
          flag = false;
        } else {
          this.passwordpass = true;
          this.passworderror = false;
          this.ifpassworderror = false;
        }
      }
      return flag;
    },
    checkPassword2() {
      //验证再次输入密码是否正确
      let password2 = this.record.password2;
      let password = this.record.password;
      if (this.isNotNullOrEmpty(password2)) {
        if (password2 != password) {
          this.passwordpass2 = false;
          this.passworderror2 = true;
        } else {
          this.passworderror2 = false;
          this.passwordpass2 = true;
        }
      }
    },
    async sendCode() {
      let flag = true;
      if (!this.isSendCode) {
        let flag = await this.genEmailCode();
        if (!flag) {
          return;
        }
        this.isSendCode = true;
        this.sendCodeText = 60;
        this.sendCodeTime = setInterval(() => {
          if (this.sendCodeText !== 1) {
            this.sendCodeText -= 1;
          } else {
            clearInterval(this.sendCodeTime);
            this.sendCodeText = "Send Code";
            this.isSendCode = false;
          }
        }, 1000);
      }
    },
    async genEmailCode() {
      //生成校验码
      if (!this.isNotNullOrEmpty(this.record.email)) {
        this.$msgDailog.showMsgBox({
          title: "Please Enter Email Address First",
        });
        return false;
      }
      let emailUrl = "api/api/genEmailCode";
      let params = {
        email: this.record.email,
      };
      let flag = false;
      await this.axios
        .post(emailUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            if (data.data.code != "1") {
              this.$msgDailog.showMsgBox({
                title: data.data.msg,
              });
            } else {
              flag = true;
            }
          }
        })
        .catch((error) => console.log(error));
      return flag;
    },
    async checkEmailCode() {
      //验证校验码
      let params = {
        email: this.record.email,
        validcode: this.record.emailcode,
      };
      let emailUrl = "api/api/checkEmailCode";
      let msg = "";
      await this.axios
        .post(emailUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            msg = data.data.code;
          }
        })
        .catch((error) => console.log(error));
      return msg;
    },
    async checkEmail() {
      //验证邮箱
      let flag = true;
      if (!this.record.email || this.record.email === "") {
        this.$msgDailog.showMsgBox({
          title: "Please Enter Email Address",
        });
        flag = false;
      } else {
        //校验邮箱是否符合规范
        let mail = this.record.email;
        if (mail.indexOf("@ptr.dito.ph") != -1 || mail.indexOf("@dito.ph") != -1 ) {
            this.$msgDailog.showMsgBox({
              title: "You cannot sign up an account with email suffix '@dito.ph' or '@ptr.dito.ph'.</br></br>"
                  + "If you are DITO employee, please login via MSS > Human Resource Management > Internal Job Portal",
            });
            flag = false;
        }
        let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!reg.test(mail)) {
          this.$msgDailog.showMsgBox({
            title: "Wrong Email Address Format",
          });
          flag = false;
        } else {
          let msg = await this.checkEmailExist();
          if (this.isNotNullOrEmpty(msg)) {
            this.$msgDailog.showMsgBox({
              title: msg,
            });
            flag = false;
          }
        }
      }
      if (!flag) {
        this.$set(this.record, "email", "");
      }
      return flag;
    },
    async checkEmailExist() {
      //验证邮箱是否已存在
      let params = {
        email: this.record.email,
      };
      let emailUrl = "api/api/portalLogin/checkEmailExist";
      let msg = "";
      msg = await this.axios
        .post(emailUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            return msg;
          }
        })
        .catch((error) => console.log(error));
      return msg;
    },
    /**getUserNO() { //获取外部人员编号
            let userno = this.record.userno;
            if (this.isNotNullOrEmpty(userno)) { //已存在则不再生成
                return;
            }
            let emailUrl = "api/api/portalLogin/getUserNO";
            let params = {};
            this.axios.post(emailUrl, params)
                .then(({
                    data
                }) => {
                    if (data.code == "1") {
                        this.portalUuid = data.data.userno;
                        this.record["userno"] = this.portalUuid;
                    };
                })
                .catch(error => console.log(error));
        },**/
    fileUploadBack() {},
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/commportallogin.vue